export default __webpack_public_path__ + "static/media/alcohol-gel.de7f1192.svg";